import { SupportedLanguages } from 'utils/current-language'

export const getLangFromHtmlTag = (): string | null => {
  const cookieLang = document.querySelector('html').getAttribute('lang')
  return SupportedLanguages[cookieLang] ? cookieLang : null
}

const currentLanguage = typeof window !== 'undefined' ? getLangFromHtmlTag() || SupportedLanguages.pl : ''

export const getCurrentLanguage = (): string => currentLanguage
